module.exports = __webpack_public_path__ + "static/veneer3-2143c9bec9d2a68e8bea933a8838ce37.jpg";